<template>
  <div>
    <div v-for="(item,index) in approvalList" :key="index" class="aaa">
      <div class="time">{{item.approveDate}}</div>
      <div class="ccc" :class="{'borderLeft':index+1<approvalList.length}">
        <div class="circle"></div>
        <div class="content">
          <div>{{item.employeeName}}（已同意）</div>
          <div v-if="item.approveReason.length>0">
            “<span
              v-for="(contentItem,index) in item.approveReason"
              :key="index"
              :class="{'atName':contentItem.id.length>0}"
              v-html="contentItem.layer"
            ></span>”
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    approvalList: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.aaa {
  display: flex;
  font-size: 0.3467rem;
  color: #333333;
  .time {
    width: 2.733333rem;
    line-height: 0.3467rem;
    font-size: 0.293333rem;
  }
  .borderLeft {
    border-left: 1px solid #e0e0e0;
    padding-bottom: 1.066667rem;
  }
  .ccc {
    flex: 1;
    position: relative;
    .circle {
      width: 0.266667rem;
      height: 0.266667rem;
      background: #d8d8d8;
      border-radius: 50%;
      position: absolute;
      top: 1px;
      left: -0.173333rem;
    }
    .content {
      font-size: 0.346667rem;
      padding-left: 0.4rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalProcess/approvalProcess_Lite.vue